import React, { FC, useMemo } from 'react';
import clsx from 'clsx';
import Style from './textField.module.scss';
import { ErrorSign } from 'uikit/wrappers';
import { BuilderFieldLabel, BuilderFieldLabelProps } from '../../wrappers/label/builderFieldLabel.component';
import { BuilderFieldError, BuilderFieldErrorProps } from '../../wrappers/error/builderFieldError.component';
import { AppTextInput, AppTextInputProps } from 'uikit/inputs';
import { BuilderFieldUnits } from '../../wrappers/units/builderFieldUnits.component';

export type AppTextFieldProps = {
  labelProps: BuilderFieldLabelProps;
  errorProps?: BuilderFieldErrorProps;
  maxLength?: number;
  units?: string;
} & Omit<AppTextInputProps, 'invalid'>;

export const AppTextField = React.forwardRef<HTMLInputElement, AppTextFieldProps>(
  ({ maxLength, errorProps, labelProps, value, units, disabled, ...rest }, ref) => {
    return (
      <BuilderFieldError {...errorProps}>
        <BuilderFieldLabel
          disabled={disabled}
          rightSection={
            <RightSection
              hasError={!!errorProps?.errors}
              length={(value as string)?.length ?? 0}
              maxLength={maxLength}
            />
          }
          {...labelProps}
        >
          <BuilderFieldUnits units={units} disabled={disabled}>
            <AppTextInput
              disabled={disabled}
              value={value}
              // @ts-ignore
              ref={ref}
              invalid={!!errorProps?.errors || (!!errorProps?.errors?.length && errorProps?.errors?.length > 0)}
              {...rest}
            />
          </BuilderFieldUnits>
        </BuilderFieldLabel>
      </BuilderFieldError>
    );
  },
);

const RightSection: FC<{
  hasError?: boolean;
  maxLength?: number;
  length: number;
}> = ({ hasError, length, maxLength }) => {
  const lengthSection = useMemo(
    () =>
      !maxLength ? null : (
        <span
          className={clsx(Style.maxLengthSection, {
            [Style.maxLengthError]: length > maxLength,
          })}
        >{`${length ?? 0}/${maxLength}`}</span>
      ),
    [maxLength, length],
  );

  return (
    <div className={Style.rightSection}>
      {lengthSection}
      {hasError && <ErrorSign />}
    </div>
  );
};
